import React from 'react';
import Button from '../../../Shared/Button/Button';
import IClassFundToolTip from './IClassFundToolTip';

import './InlineMessage.scss';

const IClassSwapInlineMessage = ({ fundName, onClick }) => {
  return (
    <div className="inline-fund-message">
      <Button
        buttonType="secondary"
        className="inline-fund-message_button"
        onClick={onClick}
      >
        Update to I Class
      </Button>

      <div className="inline-fund-message_desc">
        <span className="inline-fund-msg">
          The lower cost <IClassFundToolTip fundName={fundName} /> shares are
          available by investing the $50,000 fund minimum, per fund.
        </span>
      </div>
    </div>
  );
};

export default IClassSwapInlineMessage;
